module.exports = __webpack_public_path__ + "static/img/3.2e4e4c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/zh/3.png
// module id = hM7e
// module chunks = 0